import "../styles/preloader.css";

export default function Preloader() {
  return (
    <div className="preloader">

      {/* =====================================================
          BACKGROUND
      ===================================================== */}

      <div className="preloader__background">

        <div className="preloader__glow preloader__glow--blue"></div>

        <div className="preloader__glow preloader__glow--cyan"></div>

        <div className="preloader__stars"></div>

        <div className="preloader__wave preloader__wave--one"></div>

        <div className="preloader__wave preloader__wave--two"></div>

      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="preloader__content">


        {/* =================================================
            LOGO OFICIAL
        ================================================= */}

        <div className="preloader__logo">

          <img
            src="/images/logo-orion.png"
            alt="Orion Beach Hotel Kite House"
          />

        </div>


        {/* =================================================
            WELCOME
        ================================================= */}

        <div className="preloader__welcome">

          <span className="preloader__welcome-line"></span>

          <span>
            BIENVENIDO
          </span>

          <span className="preloader__welcome-line"></span>

        </div>


        {/* =================================================
            MESSAGE
        ================================================= */}

        <div className="preloader__message">

          <h2>
            Vive el viento.
          </h2>

          <h3>
            Descansa en Orion.
          </h3>

          <p>
            Preparando tu experiencia
            en La Guajira
          </p>

        </div>


        {/* =================================================
            LOADER
        ================================================= */}

        <div className="preloader__loader">

          <div className="preloader__loader-track">

            <div className="preloader__bar"></div>

          </div>


          <div className="preloader__loading">

            <span>
              ORION BEACH HOTEL
            </span>

            <span>
              LA GUAJIRA · COLOMBIA
            </span>

          </div>

        </div>


        {/* =================================================
            BOTTOM BRAND
        ================================================= */}

        <div className="preloader__bottom">

          <span>
            BEACH HOTEL
          </span>

          <i></i>

          <span>
            KITE HOUSE
          </span>

        </div>

      </div>

    </div>
  );
}